import { Chart as ChartJS, ArcElement } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import styled from 'styled-components';

ChartJS.register(ArcElement);

const EmptyDeviceChart = () => {
  const options = {
    responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: { right: 160 }
    },
    plugins: {
      tooltip: { enabled: false },
      legend: { display: false }
    }
  };

  const data = {
    datasets: [
      {
        data: [3, 3, 10, 18, 26, 40],
        backgroundColor: [
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4',
          '#DDE0E4'
        ],
        borderColor: '#FFFFFF',
        borderWidth: 1
      }
    ]
  };

  return (
    <PieWrapper className="mx-auto w-100">
      <Pie data={data} options={options} />
    </PieWrapper>
  );
};

export default EmptyDeviceChart;

const PieWrapper = styled.div`
  aspect-ratio: 1 / 1;
  max-width: 350px !important;
  @media (min-width: 992px) {
    max-width: 400px !important;
  }
`;
